import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      form, // via withState
      setForm, // via withState
      setModal, // via redux actions
      setApproved, // via withState
      setDiscountAmount, // via withState
      applyForFinancialAid // via withMutation
    } = props

    const handleChangeFormField = fieldName => event => {
      setForm({ ...form, [fieldName]: event.target.value })
    }

    const handleClickSubmit = event => {
      event.preventDefault()

      // Convert AGI from dollars to cents
      const agiInCents = parseInt(form.adjustedGrossIncome) * 100

      applyForFinancialAid({
        variables: {
          input: {
            locationId: form.locationId,
            familySize: parseInt(form.familySize),
            adjustedGrossIncome: agiInCents,
            specialCircumstances: form.specialCircumstances || null
          }
        }
      })
    }

    const handleClickClose = () => {
      // Reset form and close modal
      setForm({
        locationId: '',
        familySize: '',
        adjustedGrossIncome: '',
        specialCircumstances: ''
      })
      setApproved(false)
      setDiscountAmount(null)
      setModal({ open: false })
    }

    return (
      <WrappedComponent
        onChangeFormField={handleChangeFormField}
        onClickSubmit={handleClickSubmit}
        onClickClose={handleClickClose}
        {...props}
      />
    )
  }
}

export default withEventHandlers
